import {
  IdentificationFlow,
  isIdentificationState,
} from "./domain/IdentificationState";

export function convertAnyToIdentificationFlow(any: any): IdentificationFlow {
  if (Array.isArray(any)) {
    const identificationStates = any.map((e) => {
      if (!isIdentificationState(e))
        throw new Error(`Could not convert to identification state ${e}`);
      return e;
    });

    const failed = identificationStates.find((s) => s.type === "Failed");
    const notFailures = identificationStates.filter((s) => s.type !== "Failed");

    const [
      initialized,
      authenticationRequested,
      authenticated,
      consentRequested,
      consentGranted,
    ] = notFailures;

    const flow: IdentificationFlow = {};

    if (initialized?.type === "Initialized") flow["initialized"] = initialized;
    if (authenticationRequested?.type === "AuthenticationRequested")
      flow["authenticationRequested"] = authenticationRequested;
    if (authenticated?.type === "Authenticated")
      flow["authenticated"] = authenticated;
    if (consentRequested?.type === "ConsentRequested")
      flow["consentRequested"] = consentRequested;
    if (consentGranted?.type === "ConsentGranted")
      flow["consentGranted"] = consentGranted;

    if (failed?.type === "Failed") flow["failed"] = failed;

    if (Object.keys(flow).length === 0)
      throw new Error("Empty response from server");

    return flow;
  }

  throw new Error(
    `Could not convert response ${JSON.stringify(any)} from JSON.`,
  );
}

export default async function getIdentificationFlow(): Promise<IdentificationFlow> {
  const isDevelop = process.env.NODE_ENV === "development";
  const host = isDevelop ? "http://localhost:64209" : "";

  const fetchConfig: RequestInit = isDevelop
    ? {
        method: "GET",
        mode: "cors",
        credentials: "include",
      }
    : { method: "GET" };

  const target = `${host}/identification/v1/state`;
  const response = await fetch(target, fetchConfig);
  const json = await response.json();
  return convertAnyToIdentificationFlow(json);
}
